export const lfoShapeOptions = [
        {value: 'square', label:'Square'},
        {value: 'sine', label:'Sine'},
        {value: 'triangle', label:'Triangle'},
        {value: 'sawtooth', label:'Sawtooth'}
    ];

export function getLFOShapeOption(value) {
    for (var i=0; i < lfoShapeOptions.length; i++) {
        if (lfoShapeOptions[i].value === value) {
            return lfoShapeOptions[i];
        }
    }
    return null;
}

